import type { ReactNode } from 'react';
import { toast, type ExternalToast } from 'sonner';

/** Errors stay longer than the 5 s Toaster default: they carry text to act on. */
export const ERROR_TOAST_DURATION_MS = 8000;

/**
 * Shows an error toast for {@link ERROR_TOAST_DURATION_MS}. The duration is not
 * an option, so every error toast that goes through here stays up equally long.
 */
export function toastError(
  text: ReactNode,
  opts?: Omit<ExternalToast, 'duration'>,
): string | number {
  return toast.error(text, { ...opts, duration: ERROR_TOAST_DURATION_MS });
}
